import { EMPTY_VALUE } from "@/components/widgets/Revision/config";

const CONSENSUS_STATES = [EMPTY_VALUE, "Disagree", "Normal", "Agree"];

const byDispersion = <T>(dispersion: number | undefined, values: Array<T>) =>
	dispersion == null
		? values[0]
		: dispersion < 0
			? values[1]
			: dispersion! <= 1
				? values[2]
				: values[3];

export const stateByConsensus = (dispersion: number | undefined) =>
	byDispersion(dispersion, CONSENSUS_STATES);
